/**
* DevExpress HTML/JS Reporting (viewer\parameters\previewParametersModel.js)
* Version:  24.1.7
* Build date: Oct 28, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { ParametersPanelModelBase } from './parametersPanelModelBase';
import { getLocalization } from '@devexpress/analytics-core/analytics-internal-native';
export class PreviewParametersPanelModel extends ParametersPanelModelBase {
    constructor(reportPreview, parameterHelper, enableKeyboardSupport) {
        super(reportPreview, parameterHelper, enableKeyboardSupport);
        this.submit = () => {
            if (this.parametersLoading)
                return;
            this.parametersLoading = true;
            const promise = reportPreview.startBuild();
            promise && promise.then((val) => { this.parametersLoading = false; });
        };
        this.buttons.push({
            text: getLocalization('Submit', 'ASPxReportsStringId.ParametersPanel_Submit'),
            onClick: (params) => this._validateAndSubmit(params)
        });
    }
    initialize(originalParametersInfo) {
        super.initialize(originalParametersInfo);
        if (!originalParametersInfo || this._parametersHolder.documentId)
            return;
        if (!originalParametersInfo.shouldRequestParameters || this.isEmpty) {
            this.submit();
        }
        else {
            this._parametersHolder.removeEmptyPages();
            this.tabInfo.active = true;
            if (this.tabInfo.visible && this.tabInfo.collapsed !== undefined)
                this.tabInfo.collapsed = false;
            this._popupVisible = true;
            this._parametersHolder.pageLoading = false;
        }
    }
}
